export default __webpack_public_path__ + "static/media/er.8727ac14.jpg";